import React from "react";
import "../styles/Dashboard.css";

const DashboardAnalytics = ({ totalParticipations, totalTeachers, totalStudents, totalFundraisers, totalDonations }) => {
    const data = [
        { label: "Participations", value: totalParticipations },
        { label: "Teachers", value: totalTeachers },
        { label: "Students", value: totalStudents },
        { label: "Fundraisers", value: totalFundraisers },
        { label: "Donations (RM)", value: totalDonations.toFixed(2) },
    ];

    return (
        <div className="dashboard-analytics">
            {data.map((item, index) => (
                <div key={index} className="dashboard-card">
                    <h3>{item.label}</h3>
                    <p>{item.value}</p>
                </div>
            ))}
        </div>
    );
};

export default DashboardAnalytics;
